
import Vue from 'vue'
import {Component, Watch} from 'vue-property-decorator'
import {Action, Getter, namespace} from 'vuex-class'
import BaseCardContainer from '@/containers/base/BaseCardContainer.vue'
import BlocSmsForm from '@/components/forms/SmsBlocTextForm.vue'
import VueScrollTo from 'vue-scrollto'

const smsModule = namespace('sms')

@Component({
  components: {
    BaseCardContainer,
    BlocSmsForm
  }
})
export default class BlocTextUpdate extends Vue {
  @smsModule.Action('getSmsBlocTextByIdAction') getSmsBlocTextById: any
  @smsModule.Action('getSmsBlocTextsAction') getSmsBlocTexts: any
  @smsModule.Action('updateSmsBlocTextAction') updateSmsBlocText: any
  @smsModule.Getter('smsBlocTextGetter') smsBlocText: any

  mounted() {
    this.getSmsBlocTextById(this.$route.params.id)
    this.$nextTick(() => VueScrollTo.scrollTo('#form'))
  }

  @Watch('$route.params.id', {immediate: true, deep: false})
  onUrlChange(newVal: any) {
    this.getSmsBlocTextById(newVal)
  }

  onSubmit(data: any) {
    this.updateSmsBlocText({
      id: this.$route.params.id,
      formParams: data
    }).then(async (data: any) => {
      await this.getSmsBlocTexts()
      this.$router.push({name: 'BlocSmsList'})
    })
  }

  onCancel() {
    this.$router.push({name: 'BlocSmsList'})
  }
}
